import { categories } from '@/data/homeContent';

export function categoriaLabel(slug?: string | null): string {
  if (!slug) return '—';
  const found = categories.find((c) => c.slug === slug.toLowerCase());
  return found?.label ?? slug;
}
